import { LF, NBSP } from '../../constants/symbols';

export const REWARD_TITLE_VARIANTS = {
  desktop: `Получайте свою долю${LF}от${NBSP}выплаты застройщика`,
  tablet: `Получайте свою долю${NBSP}от${NBSP}выплаты застройщика`,
  phone: `Получайте свою долю${LF}от${NBSP}выплаты застройщика`,
};

export const TYPOGRAPHY = {
  CALCULATOR_TITLE: 'Рассчитайте ваше вознаграждение',
  REWARD_TITLE: REWARD_TITLE_VARIANTS,
};
